import importCalendarEventService from 'owa-calendar-services/lib/services/importCalendarEventService';
import ImportCalendarEventResponseMessage from 'owa-service/lib/contract/ImportCalendarEventResponseMessage';

// Analytics imports
import datapoints from '../datapoints';
import { PerformanceDatapoint } from 'owa-analytics/lib/datapoints/PerformanceDatapoint';
import { DatapointStatus } from 'owa-analytics/lib/types/DatapointEnums';

export default async function addToCalendarAttachmentService(
    attachmentId: string,
    content: string | null,
    importedItemFolderId: string | null
): Promise<ImportCalendarEventResponseMessage> {
    const perfDataPoint = new PerformanceDatapoint(
        datapoints.AddToCalendarServiceResult.datapoint.name
    );
    try {
        const response: ImportCalendarEventResponseMessage = await importCalendarEventService(
            content,
            importedItemFolderId,
            attachmentId
        );
        perfDataPoint.addCustomData(
            datapoints.AddToCalendarServiceResult.datapoint.customData(
                response.ResponseClass,
                response.NumberOfEventsImported
            )
        );
        perfDataPoint.end();
        return response;
    } catch (error) {
        perfDataPoint.endWithError(DatapointStatus.ServerError, error);
        return null;
    }
}
